document.addEventListener("DOMContentLoaded", () => {
    checkUserLocation();
});

function checkUserLocation() {
    fetch("https://ipinfo.io/json")
        .then((res) => res.json())
        .then((data) => {
            console.log("Country Code:", data.country);

            let isAdmin = document.querySelector("#PageContainer")?.dataset.isAdmin === "true";

            // Stay on the site if the user is from IL or is an admin
            if (data.country === "IL" || isAdmin) {
                return;
            }

            // Redirect based on country
            redirectUser(data.country);
        })
        .catch((error) => console.error("Error fetching IP info:", error));
}

function redirectUser(country) {
    let redirectUrl = '';

    switch (country) {
        case 'US':
            redirectUrl = 'https://sabinamusayev.com';
            break;
        default:
            redirectUrl = 'https://sabina-musayev-eu.myshopify.com';
            break;
    }

    window.location.href = redirectUrl;
    sessionStorage.clear();
    toggleStickyPopup();
}
